import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '../../../../../generic/ui/SearchInput';
import { DateRangePicker } from '../../../../../generic/ui/DatePicker';

interface Props {
    input: string;
    setInput: (value: string) => void;
    setDate: Dispatch<SetStateAction<string>>;
    setDateEnd: Dispatch<SetStateAction<string>>;
    handleDate: (e: object | object[]) => void;
    selectedDate: Date | Date[] | false;
    setDefaultDate: Date | Date[];
    placeholder?: string;
}

const KnisotSelectBar: React.FC<Props> = ({
    input,
    setInput,
    setDate,
    setDateEnd,
    handleDate,
    selectedDate,
    setDefaultDate,
    placeholder,
}) => {
    const [t] = useTranslation('knisa');

    return (
        <SelectBarShell>
            <SearchInput
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder={placeholder ?? t('knisa_create_page_search_placeholder')}
            />
            <DateRangePicker
                selected={setDefaultDate ? selectedDate : false}
                setDate={setDate}
                setDateEnd={setDateEnd}
                onChange={(dates) => handleDate(dates as unknown as object | object[])}
            />
        </SelectBarShell>
    );
};

export default KnisotSelectBar;

const SelectBarShell = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`;
